<template>
  <div class="Notification-container" :class="{ 'Notification-new': notification.new }" @click="handleClick">
    <v-icon class="Notification-icon">mdi-calendar</v-icon>
    <h3>{{ formattedNotification.title }}</h3>
    <div class="Notification-bottom">
      <span>{{ formattedNotification.service }}</span>
      <span>{{ formattedNotification.date }}</span>
      <span>{{ formattedNotification.hour }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },

  computed: {
    formattedNotification() {
      return {
        title: this.$t('notifications.title', { fullName: this.notification.appointment.customerFullName }),
        date: this.formatDate(this.notification.appointment.beginDateTime),
        hour: this.formatHour(this.notification.appointment.beginDateTime),
        service: this.notification.appointment.service.name
      }
    }
  },

  methods: {
    formatDate(date) {
      const options = {
        day: 'numeric',
        month: 'long'
      }
      const newDate = new Date(date)
      return newDate.toLocaleString(this.$route.params.lang, options)
    },
    formatHour(date) {
      const options = {
        hour: 'numeric',
        minute: 'numeric'
      }
      const newDate = new Date(date)
      return newDate.toLocaleString(this.$route.params.lang, options)
    },
    handleClick() {
      this.$store.commit('SET_CALENDAR_SELECTED_APPOINTMENT', this.notification.appointment)
    }
  }
}
</script>

<style scoped lang="scss">
.Notification-bottom {
  display: flex;
  justify-content: space-between;
}

.Notification-container {
  cursor: pointer;
  position: relative;
  padding: 10px 30px 10px 80px;
  font-size: 0.9em;
  color: var(--v-text-base);
  border-top: 1px solid var(--v-text-lighten2);
}

.Notification-container h3 {
  font-size: 1.2em;
  font-weight: 500;
  line-height: 1.2em;
  margin-bottom: 12px;
}

.Notification-icon {
  font-size: 2.5em;
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  color: var(--v-text-base);
}

.Notification-new {
  background: var(--v-lightGrey-base);
}
</style>
